const model = {
    brandDetails: null,
    loading: false,
    error: null,
};

export default model;
